import { createRouter, createWebHistory } from 'vue-router'
import Versions from '../views/VersionsView.vue'
import AppLink from '../views/AppLink.vue'
import MarketPlace from '../views/MarketPlace.vue'

const routes = [
  {
    path: '/versions',
    name: 'Versions',
    component: Versions
  },
  { path: '/a',
    name: 'AppLink',
    component: AppLink
  },
  { path: '/a/:data',
    name: 'AppLink',
    component: AppLink
  },
  { path: '/marketplace/:data',
    name: 'MarketPlaceLink',
    component: MarketPlace
  },
  {
    path: '/config-update',
    name: 'Config',
    component: () => import('../views/Config.vue')
  },
  {
    path: '/hello',
    name: 'HelloWorld',
    component:  () => import('../views/HelloWorld.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
